/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DestroyRef, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {catchError, defer, EMPTY, finalize, Subject, switchMap} from 'rxjs';

import {AdnSelectSearchElement} from '../../common/directives/adn-select/adn-select.component';
import {CouponApiService, CouponProduct} from './coupon-api.service';

export class CouponProductSearchState {
  readonly results = signal<CouponProduct[]>([]);
  readonly loading = signal(false);
  readonly loadFailed = signal(false);

  readonly search = (searchElement: AdnSelectSearchElement): void => {
    this.searchTerms.next(searchElement.search || '');
  };

  private readonly searchTerms = new Subject<string>();

  constructor(api: CouponApiService, destroyRef: DestroyRef) {
    this.searchTerms.pipe(
      switchMap((query) => defer(() => {
        this.loading.set(true);
        this.loadFailed.set(false);
        return api.searchProducts(query).pipe(
          catchError(() => {
            this.results.set([]);
            this.loadFailed.set(true);
            return EMPTY;
          }),
          finalize(() => this.loading.set(false))
        );
      })),
      takeUntilDestroyed(destroyRef)
    ).subscribe((results) => this.results.set(results));
  }
}
